<template>
    <div class="content">
        <div class="survey_div" style="margin-bottom: .02rem;">
            <div class="searchBar">
                <div class="organizationName" @click="show=true;">
                    <span v-text="organizationInfo.organizationName">武汉天河机构</span>&nbsp;
                    <van-icon name="arrow-down" />
                </div>
                <div class="ckTime">
                    <!-- <span @click="searchData(0)">今天</span> -->
                    <span @click="searchData(1)" :class="timeIndex==1?'on':''">最近1天</span>
                    <span @click="searchData(7)" :class="timeIndex==7?'on':''">最近7天</span>
                    <span @click="dataShow=true" :class="timeIndex=='more'?'on':''">更多&nbsp;<van-icon name="arrow-down" /></span>
                </div>
            </div>
        </div>
        <div class="survey_div">
            <div class="organizationInfo">
                <div style="width: 50%;">
                    <p><span>当前任务</span></p>
                    <p><strong><font color="#FF8C14" v-text="taskPor">0/0</font></strong></p>
                    <p><a href="javascript:void(0)" @click="$router.push('/taskList?id='+organizationInfo.id)">查看详情</a></p>
                </div>
                <div style="width: 50%;">
                    <p><span>余额(元)</span></p>
                    <p><strong><font color="#FF8C14" v-text="organizationInfo.accountBalance/100">00.00</font></strong></p>
                    <p><a href="javascript:void(0)" @click="$router.push('/newRecharge?id='+organizationInfo.id)">充值</a></p>
                </div>
            </div>
        </div>
        <div class="survey_div">
            <div class="chart_head">
                <div style="width: 24%;">
                    <strong class="num" v-text="chartData.calledTotal">1000</strong>
                    <span class="desc">总拨打量</span>
                </div>
                <span class="line"></span>
                <div style="width: 24%;">
                    <strong class="num" v-text="chartData.abCountTotal">1000</strong>
                    <span class="desc">意向量</span>
                </div>
                <span class="line"></span>
                <div style="width: 24%;">
                    <strong class="num" v-text="chartData.connectionRate+'%'">100%</strong>
                    <span class="desc">接通率</span>
                </div>
                <span class="line"></span>
                <div style="width: 24%;">
                    <strong class="num" v-text="chartData.phoneBillTotal">0</strong>
                    <span class="desc">消耗话费(元)</span>
                </div>
            </div>
            <div class="chart_body">
                <div class="barTitle">
                    <strong>意向统计</strong>
                </div>
                <div class="chartData" id="echarts" style="width: 100%;height: 4rem;display: flex;justify-content: center;align-items: center;">
                    
                </div>
            </div>
            <div class="chart_foot">
                <p style="display: flex;justify-content: center;align-items: center;">
                    <span class="type" style="border-color: #FF6F43;">意向极强</span>
                    <span class="type" style="border-color: #FF9674;">一般意向</span>
                    <span class="type" style="border-color: #FFAA6E;">未接号码</span>
                    <span class="type" style="border-color: #FFB868;">无意向</span>
                </p>
                <p style="display: flex;justify-content: center;align-items: center;">
                    <span class="type" style="border-color: #FFCC6E;">年龄不符</span>
                    <span class="type" style="border-color: #BAD5FF;">位置不符</span>
                    <span class="type" style="border-color: #93BEFF;">潜在投诉</span>
                    <span class="type" style="border-color: #3B89FF;">无效号码</span>
                </p>
            </div>
        </div>
        <div class="survey_div" style="margin-bottom: .02rem;">
            <div class="barTitle">
                <strong style="width: 2.2rem;">有效意向</strong>
                <div class="ckTime">
                    <span><van-icon name="search" /><input type="text" v-model="table.number" name="text" @blur="table.currentPage=1;onLoad();" style="border:none;height: .36rem;width: 1.6rem;padding-left: .1rem;"></span>
                    <span @click="statusShow=true"><font v-text="tableStatus">状态</font>&nbsp;<van-icon name="arrow-down" /></span>
                </div>
            </div>
        </div>
        <div class="survey_div">
            <van-list v-model="table.loading" :finished="table.finished" finished-text="没有更多了" @load="onLoad" v-if="listLoading">
                <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
                <div class="clueItem" v-for="item in table.list" @click="$router.push('/clueDesc?id='+item.lastRecordId)">
                    <p>
                        <span class="cluePhone" v-text="item.phone"></span>
                        <span class="clueStatic" v-if="item.status=='3'"><font color="#3B89FF">待跟进</font></span>
                        <span class="clueStatic" v-if="item.status=='4'"><font color="#07CFBF">确认到店</font></span>
                        <span class="clueStatic" v-if="item.status=='5'"><font color="#FF5A5A">邀约失败</font></span>
                        <span class="clueStatic" v-if="item.status=='6'"><font color="#FF5A5A">未到店</font></span>
                        <span class="clueStatic" v-if="item.status=='7'"><font color="#FF5A5A">到店未试听</font></span>
                        <span class="clueStatic" v-if="item.status=='8'"><font color="#07CFBF">试听成功</font></span>
                        <span class="clueStatic" v-if="item.status=='9'"><font color="#07CFBF">成交</font></span>
                        <span class="clueStatic" v-if="item.status=='10'"><font color="#FF5A5A">未成交</font></span>
                    </p>
                    <p>
                        <span class="clueTime" v-text="'跟进时间：'+item.updateTime">2020年1月15日 17:36:17</span>
                        <span class="clueHref">查看详情></span>
                    </p>
                </div>
            </van-list>
        </div>
        <van-popup v-model="show" position="bottom" round>
            <div style="padding: .4rem .4rem 0 .4rem;">
                <strong style="font-size: .32rem;color: #010101;">切换机构</strong>
            </div>
            <div style="padding: 0 .4rem;">
                <p v-for="item in organizationList" class="recharge4" @click="init(item)" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
                    <span v-text="item.organizationName"></span>
                </p>
            </div>
        </van-popup>
        <van-popup v-model="statusShow" position="bottom" round>
            <div style="padding: .4rem .4rem 0 .4rem;">
                <strong style="font-size: .32rem;color: #010101;">切换状态</strong>
            </div>
            <div style="padding: 0 .4rem;">
                <p class="recharge4" @click="table.status='';tableStatus='状态';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
                    <span>全部</span>
                </p>
                <p class="recharge4" @click="table.status='3';tableStatus='待跟进';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
                    <span>待跟进</span>
                </p>
                <p class="recharge4" @click="table.status='4';tableStatus='确认到店';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
                    <span>确认到店</span>
                </p>
                <p class="recharge4" @click="table.status='5';tableStatus='邀约失败';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
                    <span>邀约失败</span>
                </p>
                <p class="recharge4" @click="table.status='6';tableStatus='未到店';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
                    <span>未到店</span>
                </p>
                <p class="recharge4" @click="table.status='7';tableStatus='到店未试听';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
                    <span>到店未试听</span>
                </p>
                <p class="recharge4" @click="table.status='8';tableStatus='试听成功';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
                    <span>试听成功</span>
                </p>
                <p class="recharge4" @click="table.status='9';tableStatus='成交';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
                    <span>成交</span>
                </p>
                <p class="recharge4" @click="table.status='10';tableStatus='未成交';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
                    <span>未成交</span>
                </p>
            </div>
        </van-popup>
        <van-calendar v-model="dataShow" type="range" @confirm="onConfirm" :min-date="minDate" :default-date="defaultDate"/>
    </div>
</template>
<script>
    import {getOpenId,getOrganizationByOpenId,subAccountList,getTaskProgressByOrganizationId,moblieSurveyStatistics,getAbClueList} from '../../api';
    import axios from 'axios';
    import Echarts from "echarts";
    export default {
        name: 'template',
        data() {
            return {
                echarts:"",
                value:"",
                show:false,
                dataShow:false,
                organizationList:[],
                organizationInfo:{
                    accountBalance:0
                },
                openId:"70cdf10d2a054b32ddb8afb6c1642046",
                wxConfig:{
                    appid:"wx9fc68a7bac8f1258",
                    url:location.href.split('#').toString()
                },
                searchObj:{
                    organizationId:"",
                    startDate:"",
                    endDate:""
                },
                token:"",
                taskPor:"",
                minDate: new Date(2019, 12, 1),
                defaultDate: [new Date(),new Date()],
                chartData:{
                    abCountTotal: 0,
                    calledTotal: 0,
                    connectionRate: 0,
                    phoneBillTotal: 0
                },
                listLoading:false,
                table:{
                    list:[],
                    finished:false,
                    loading:false,
                    currentPage: 1,
                    number: "",
                    organizationId: 0,
                    showCount: 10,
                    status: "",
                    timeEnd: "",
                    timeStart: "",
                    total:0
                },
                statusShow:false,
                timeIndex:1,
                tableStatus:"状态"
            }
        },
        methods: {
            init(item){
                this.organizationInfo=item;
                this.table = {
                    list:[],
                    finished:false,
                    loading:false,
                    currentPage: 1,
                    number: "",
                    organizationId: 0,
                    showCount: 10,
                    status: "",
                    timeEnd: "",
                    timeStart: "",
                    total:0
                };
                this.searchData(7);
                this.onLoad();
                this.show=false;
                this.listLoading = true;
            },
            formatDate(date) {
                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            },
            onConfirm(date){
                const [start, end] = date;
                this.searchObj.startDate = this.formatDate(start);
                this.searchObj.endDate = this.formatDate(end);
                this.searchData();
                this.dataShow = false;
            },
            lastDays(days){
                days = days - 1;
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * days);
                end.setTime(end.getTime());
                return [start.getFullYear()+"-"+(start.getMonth()+1)+"-"+start.getDate(), end.getFullYear()+"-"+(end.getMonth()+1)+"-"+end.getDate()];
            },
            getOrganizationList(){
                var that = this;
                subAccountList().then((res) => {
                    if(res.code==1){
                        that.organizationList = res.data;
                        if(that.organizationList.length>0){
                            // 初始化
                            that.init(that.organizationList[0]);
                        }
                    }else{
                        that.$toast("错误信息:"+res.message);
                    }
                });
            },
            searchData(days){
                var that = this;
                that.searchObj.organizationId = that.organizationInfo.id;
                if(typeof(days) != "undefined"){
                    that.searchObj.startDate = that.lastDays(days)[0];
                    that.searchObj.endDate = that.lastDays(days)[1];
                    that.timeIndex = days;
                }else{
                    that.timeIndex = "more";
                }
                getTaskProgressByOrganizationId("?organizationId="+that.searchObj.organizationId).then((res) => {
                    if(res.code==1){
                        that.taskPor = res.data.completeCount+"/"+res.data.totalCount;
                    }else{
                        that.$toast("错误信息:"+res.message);
                    }
                });
                moblieSurveyStatistics(that.searchObj).then((res) => {
                    if(res.code==1){
                        that.chartData = res.data;
                        that.setChart(res.data);
                    }else{
                        that.$toast("错误信息:"+res.message);
                    }
                });
            },
            setChart(data){
                var option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    series: [
                        {
                            name: '意向类别',
                            type:'pie',
                            radius: ['35%', '50%'],
                            color:["#ff6d42","#ff9572","#ffa769","#ffb462","#ffca6b","#b7d3ff","#7faeff","#538fff"],
                            data: [
                                {value:data.acount, name:'A  精准意向'},
                                {value:data.bcount, name:'B  一般意向'},
                                {value:data.ccount, name:'C  未接号码'},
                                {value:data.dcount, name:'D 无意向'},
                                {value:data.ecount, name:'E  年龄不符'},
                                {value:data.fcount, name:'F  位置不符'},
                                {value:data.gcount, name:'G  潜在投诉'},
                                {value:data.hcount, name:'H  无效号码'},
                            ]
                        }
                    ]
                };
                this.echarts.setOption(option);
            },
            onLoad(){
                var that = this;
                that.table.organizationId = that.organizationInfo.id;
                getAbClueList(that.table).then((res) => {
                    if(res.code==1){
                        if(that.table.currentPage==1){
                            that.table.list = [];
                        }
                        for(var i in res.data.list){
                            that.table.list.push(res.data.list[i]);
                        }
                        that.statusShow = false;
                        that.table.loading = false;
                        if(that.table.currentPage*that.table.showCount>=res.data.total){
                            that.table.finished = true;
                        }else{
                            that.table.finished = false;
                        }
                        that.currentPage++;
                    }else{
                        that.$toast("错误信息:"+res.message);
                    }
                });
            }
        },
        mounted(){
            this.openId = sessionStorage.getItem('openId');
            this.echarts = Echarts.init(document.getElementById('echarts'));
            this.getOrganizationList();
    	}
	}
</script>
<style type="text/css">
    .survey_div{
        background-color: #fff;
        width: 100%;
        margin-bottom: .2rem;
        padding: 0 .3rem;
    }
    .searchBar {
        height: 1rem;
        display: flex;
        justify-content: flex-start;
    }
    .barTitle {
        display: flex;
        height: 1rem;
        justify-content: flex-start;
        align-items: center;
    }
    .barTitle strong {
        font-size: .32rem;
        color: #222222;
    }
    .organizationName {
        color: #222222;
        font-size: .26rem;
        width: 2.2rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        overflow: hidden;
    }
    .organizationName span {
        max-width: 1.8rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .ckTime {
        width: calc(100% - 2.2rem);
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .ckTime span {
        height: .4rem;
        line-height: .36rem;
        border-radius: .2rem;
        padding: 0 .2rem;
        text-align: center;
        color: #848483;
        font-size: .22rem;
        border:.02rem solid rgba(181,181,181,1);
        display: flex;
        align-items: center;
        /*margin: 0 .1rem;*/
        margin-left: .2rem;
    }
    .ckTime .on {
        border-color:#3B89FF;
        color: #3B89FF;
    }
    .organizationInfo {
        display: flex;
        justify-content: center;
        font-size: .28rem;
        color: #777777;
        text-align: center;
        padding: .2rem 0;
    }
    .organizationInfo strong {
        font-size: .6rem;
    }
    .organizationInfo a {
        display: inline-block;
        height: .52rem;
        line-height: .52rem;
        padding: 0 .35rem;
        background:rgba(243,246,251,1);
        color: #3B89FF;
        font-size: .24rem;
        border-radius: .26rem;
    }
    .organizationInfo p {
        margin: .1rem 0;
    }
    .chart_head {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 1.50rem;
        text-align: center;
        border-bottom: .02rem solid #F3F3F3;
    }
    .chart_head .num {
        display: block;
        color: #222222;
        font-size: .36rem;
    }
    .chart_head .desc {
        display: block;
        color: #777777;
        font-size: .24rem;
        margin-top: .1rem;
    }
    .chart_head .line {
        width: 1px;
        height: .42rem;
        background:rgba(238,238,238,1);
    }
    .chart_foot {
        padding: .5rem 0;
    }
    .chart_foot .type {
        width: 1.2rem;
        height: .2rem;
        line-height: .2rem;
        border-left: .2rem solid;
        padding-left: .1rem;
        font-size: .22rem;
        color: #777777;
        margin: 0 .1rem;
    }
    .clueItem {
        padding: .15rem 0;
        border-bottom: 1px solid #F3F3F3;
    }
    .clueItem p {
        margin: .1rem 0;
        display: flex;
        justify-content: flex-start;
    }
    .clueItem .cluePhone {
        width: 70%;
        color: #000;
        font-size: .34rem;
    }
    .clueItem .clueTime {
        width: 70%;
        color: #777;
        font-size: .28rem;
    }
    .clueItem .clueStatic {
        width: 30%;
        text-align: right;
        font-size: .28rem;
    }
    .clueItem .clueHref {
        width: 30%;
        text-align: right;
        color: #999;
        font-size: .24rem;
    }
</style>


// WEBPACK FOOTER //
// src/views/survey/index.vue